import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDialogModule } from '@angular/material/dialog';

import { ContactLogDialogComponent } from './contact-log-dialog/contact-log-dialog.component';
import { ContactLogTableComponent } from './contact-log-table/contact-log-table.component';
import { ContactLogFormComponent } from './contact-log-form/contact-log-form.component';

@NgModule({
  declarations: [
    ContactLogDialogComponent,
    ContactLogTableComponent,
    ContactLogFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatDialogModule,
  ],
  exports: [
    ContactLogDialogComponent,
    ContactLogTableComponent,
  ]
})
export class ContactLogsModule { }